module.exports = __webpack_public_path__ + "img/upload-cnh.c04f2563.jpg";